<div class="controls" *ngIf="this.subPointsShown">
  <button class="left-arrow" (click)="handleChange(-1)">
    <txtb-icons type="backArrow"></txtb-icons>
  </button>
  <span class="images-count"> {{ activeElement }}&nbsp;z&nbsp;{{ subSectionLength }} </span>
  <button class="right-arrow" (click)="handleChange(1)">
    <txtb-icons type="backArrow"></txtb-icons>
  </button>
</div>
